import React from "react";
import { useAuth } from "../context/AuthContext";

const containerStyles = {
  backgroundColor: "#ffffff",
  borderRadius: "18px",
  border: "1px solid #e2e8f0",
  padding: "28px",
  boxShadow: "0 18px 40px rgba(15, 23, 42, 0.06)",
  maxWidth: "760px",
};

function ModuleRoute({
  moduleKey,
  title = "Acceso restringido",
  description = "Tu cuenta no tiene permiso para entrar a este sector desde la sucursal activa.",
  children,
}) {
  const { canAccessModule } = useAuth();

  if (canAccessModule(moduleKey)) {
    return children;
  }

  return (
    <div style={containerStyles}>
      <h1 style={{ marginTop: 0, marginBottom: "10px", color: "#0f172a" }}>{title}</h1>
      <p style={{ margin: 0, color: "#475569", lineHeight: 1.6 }}>{description}</p>
    </div>
  );
}

export default ModuleRoute;
